import React from "react";
import { Button, Modal } from "antd";
import RetestTable from "./tables/RetestTable";
import DataOpsSampleModalHeader from "./DataOpsSampleModalHeader";
import { buildRetestStatusCountLabel } from "./utils/retestUtils";
import "../Dashboard/CustomerSubmissionDetailModal.css";
import "../Dashboard/TestMetrics.css";

/**
 * Chart / row drill-down — export-API retest subset.
 * Pass headerItems for the labeled Sample__Modal header (row click);
 * otherwise title/subtitle are used (chart click).
 */
export default function RetestDrillDownModal({
  open,
  title,
  subtitle,
  headerItems = null,
  rows,
  loading = false,
  categoryLabelById = null,
  customerLookup = null,
  onClose,
}) {
  const tableRows = Array.isArray(rows) ? rows : [];
  const hasHeaderItems = Array.isArray(headerItems) && headerItems.length > 0;
  const displaySubtitle = [subtitle, buildRetestStatusCountLabel(tableRows)]
    .filter(Boolean)
    .join(" · ");

  return (
    <Modal
      className="Sample__Modal DataOpsAnalytics__DrillDownModal"
      centered
      open={open}
      title={(
        <div className="DataOpsAnalytics__DrillDownHeader">
          {hasHeaderItems ? (
            <DataOpsSampleModalHeader items={headerItems} />
          ) : (
            <div className="DataOpsAnalytics__DrillDownHeaderText">
              <div className="DataOpsAnalytics__DrillDownTitle">{title || "Retest breakdown"}</div>
              {displaySubtitle ? (
                <div className="DataOpsAnalytics__DrillDownSubtitle">{displaySubtitle}</div>
              ) : null}
            </div>
          )}
        </div>
      )}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
      width="80vw"
      destroyOnClose
    >
      <RetestTable
        rows={tableRows}
        loading={loading}
        showExportColumns
        categoryLabelById={categoryLabelById}
        customerLookup={customerLookup}
      />
    </Modal>
  );
}
